import {
  distinctUntilChanged,
  groupBy,
  map,
  mergeMap,
  pluck,
  switchMap,
} from "rxjs/operators";
import { object$ } from "../../../../utils/stream-utils";

const create$ = (state$) => {
  return state$.pipe(
    pluck("three", "materials"),
    distinctUntilChanged(),
    // TODO: remove entity stream
    mergeMap((materials) => materials),
    groupBy(
      (material) => material.id,
      (material) => material
    ),
    mergeMap((group$) =>
      group$.pipe(
        distinctUntilChanged(),
        switchMap((definition) => {
          object$(state$, definition);
        }),
        distinctUntilChanged()
      )
    )
  );
};

export const createGetMaterial$ = (state$) => {
  return (id) => {
    return state$.pipe(
      pluck("three", "materials"),
      distinctUntilChanged(),
      map((materials) => materials && materials.find((item) => item.id === id)),
      switchMap((definition) => {
        return object$(state$, definition);
      }),
      distinctUntilChanged()
    );
  };
};

export default create$;
